import React, { useMemo } from 'react'
import { get } from 'lodash'

import { Label } from '@scoir/tabs'

import FwdRefNavLink from 'components/FwdRefNavLink'
import { DISPLAY_ORDER, TABS, getIcon } from './outreach-tabs'

const getTabConfiguration = (url, page) => {
  const tab = TABS[page]
  const value = tab.value
  const to = tab.getUrl(url)
  const q = tab.queryParam || ''
  const text = tab.text
  const icons = get(tab, 'icons', {})

  const tabConfiguration = (data = 0, currentPage) => {
    const active = page === currentPage
    const location = window.location
    const currentUrl = location.pathname + location.search
    const icon = getIcon(icons, active)
    const actualTo = active ? currentUrl : to + q

    return {
      to: actualTo,
      value,
      component: FwdRefNavLink,
      labelText: text,
      'aria-label': 'Click to view ' + text,
      label: (
        <Label
          icon={icon}
          count={data}
        >
          {text}
        </Label>
      ),
    }
  }

  return tabConfiguration
}

export const useOutreachTabs = (url) => {
  const tabs = useMemo(() => {
    return DISPLAY_ORDER.map((page) => {
      return getTabConfiguration(url, page)
    })
  }, [url])
  return tabs
}
